import React from 'react'

const CoreComponent21 = ({innovative}) => {
  return (
    <div>
        <div className="row  d-flex justify-content-center align-items-center">
        <div className="col-lg-5">
          <h2 className="pe-lg-1 h2-heading lh-base ">{innovative.maintitle} </h2>
          <p className="pe-lg-2 mt-2 h1-para lh-base ">{innovative.maindesc}</p>
        </div>
        <div className="col-lg-7 row mt-3 mt-lg-0 row d-flex justify-content-between">
          {innovative.loop.map((item, i) => (
            <div key={i} className="col-md-6 mb-4 mb-lg-4 pb-1">
              <div className=" border p-3 shadow mt-1 text-start  h-100 " >
                <img
                  src={item.icon}
                  alt=""
                  style={{ height: 45, width: 45 }}
                  className="mx-0"
                />
                <h3 className="h3-heading lh-base text-start fs-4 mt-lg-3 mb-lg-3 mt-2 mb-1 ">{item.title}</h3>
                <p className="h3-para lh-base fs-6 ">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CoreComponent21